module.exports = __webpack_public_path__ + "static/media/google-icon.be452a42.svg";